import _regenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.ends-with.js";
import axios from 'axios';
import { Message } from 'element-ui';
import { getToken } from '@/utils/auth';
import { refreshAccessToken, handleAuthExpired, isAccessTokenExpired } from '@/utils/token-refresh';
var service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 60000
});
function showError(message) {
  Message({
    message: message || 'Error',
    type: 'error',
    duration: 5 * 1000
  });
}
function shouldBypassRefresh() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return !!(config.skipAuthRefresh || config.noAuth);
}
function getResponseMessage(data, fallback) {
  return (data === null || data === void 0 ? void 0 : data.message) || (data === null || data === void 0 ? void 0 : data.error_description) || (data === null || data === void 0 ? void 0 : data.error) || fallback;
}
function isForcedOfflineMessage() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return /异地登录|别处登录|它处登录|其他地方登录|已在.*登录|强制下线|被踢|踢下线|重新登录/.test(message);
}
function handleForbidden(message) {
  var errorMessage = message || '无权限访问该资源，请联系管理员确认权限。';
  if (isForcedOfflineMessage(errorMessage)) {
    return handleAuthExpired(errorMessage, '账号已下线');
  }
  showError(errorMessage);
  return Promise.reject(new Error(errorMessage));
}
function retryWithRefresh() {
  return _retryWithRefresh.apply(this, arguments);
}
function _retryWithRefresh() {
  _retryWithRefresh = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var originalConfig,
      _yield$refreshAccessT,
      accessToken,
      _args = arguments,
      _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          originalConfig = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          if (!(shouldBypassRefresh(originalConfig) || originalConfig._retry)) {
            _context.n = 1;
            break;
          }
          return _context.a(2, handleAuthExpired('登录已过期，请重新登录。'));
        case 1:
          originalConfig._retry = true;
          _context.p = 2;
          _context.n = 3;
          return refreshAccessToken();
        case 3:
          _yield$refreshAccessT = _context.v;
          accessToken = _yield$refreshAccessT.accessToken;
          originalConfig.headers = originalConfig.headers || {};
          originalConfig.headers.Authorization = "Bearer ".concat(accessToken);
          return _context.a(2, service(originalConfig));
        case 4:
          _context.p = 4;
          _t = _context.v;
          console.error('[auth] refresh failed:', _t);
          if (isAccessTokenExpired(getToken(), 0)) {
            _context.n = 5;
            break;
          }
          return _context.a(2, Promise.reject(_t));
        case 5:
          return _context.a(2, handleAuthExpired('登录已过期，请重新登录。'));
      }
    }, _callee, null, [[2, 4]]);
  }));
  return _retryWithRefresh.apply(this, arguments);
}
service.interceptors.request.use(function (config) {
  config.headers['User-Device'] = config.headers['User-Device'] || 'web';
  config.headers['User-Device-Name'] = config.headers['User-Device-Name'] || navigator.platform || 'Web';
  if (getToken() && !config.noAuth) {
    config.headers.Authorization = "Bearer ".concat(getToken());
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});
service.interceptors.response.use(function (response) {
  var res = response.data;
  var requestUrl = response.config.url || '';
  if (requestUrl.indexOf('download') !== -1 || requestUrl.indexOf('import') !== -1 || requestUrl.endsWith('/export') || requestUrl.endsWith('/diagram')) {
    return res;
  }
  if (response.status === 204) {
    return {
      code: 200,
      message: 'success',
      data: null
    };
  }
  if (res.code < 200 || res.code >= 300) {
    if (res.code === 401) {
      return retryWithRefresh(response.config);
    }
    if (res.code === 403) {
      return handleForbidden(res.message);
    }
    showError(res.message);
    return Promise.reject(new Error(res.message || 'Error'));
  }
  return res;
}, function (error) {
  if (!error.response) {
    showError(error.message);
    return Promise.reject(error);
  }
  var status = error.response.status;
  var message = getResponseMessage(error.response.data, error.message);
  if (status === 400) {
    showError(message);
  } else if (status === 401) {
    return retryWithRefresh(error.config || {});
  } else if (status === 403) {
    return handleForbidden(message);
  } else if (status === 422) {
    var _error$response$data;
    var errors = ((_error$response$data = error.response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.errors) || {};
    var keys = Object.keys(errors);
    var errMsg = keys.length > 0 ? errors[keys[0]][0] : error.message;
    showError(errMsg);
  } else if (status === 502) {
    showError('无法连接服务器, 请稍候再试.');
  } else {
    showError(message);
  }
  return Promise.reject(error);
});
export default service;